<template>
	<div class="py-0 footer">
			<b-container>
				<b-row class="justify-content-center">
					<b-col cols="12" class="my-auto text-right">
						<b-link href="https://mobysuite.com" target="_blank"><b-img :src="require('@/assets/images/powered-by.png')" class="footer-logo" alt=""></b-img></b-link>
					</b-col>
				</b-row>
			</b-container>
		</div>
</template>
<script>
export default {
	name: "Footer",
	data() {
		return {
			user: this.$auth.user(),
			year: new Date().getFullYear(),
		}
	},
	mounted() {

	},
	computed: {
		menuTitle() {
			switch (this.$route.name) {
				case 'information':
					return 'Mis Datos';
				case 'quote':
					return 'Cotizar';
				case 'myquotes':
					return 'Mis Cotizaciones';
				case 'index':
					return 'Mi Depto';
				default:
					return 'Menú';
			}
		},
		background() {
			return this.$store.getters.getCustomerData ? this.$store.getters.getCustomerData.header_background_url : null;
		},
		logo() {
			return this.$store.getters.getCustomerData ? this.$store.getters.getCustomerData.logo_1_url : null;
		},
	},
};
</script>
